export default __webpack_public_path__ + "static/media/ALVA.6e917e9e.png";